import React, { useEffect } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Paper, Typography } from '@material-ui/core';
import { Close, Report, Warning } from '@material-ui/icons';
// @ts-ignore
import { useHistory } from 'react-router-dom';
import axios_instance from '../../../services/auth/jwt/config';

interface DeptWarnDialogProps {

}

export default function DeptWarnDialog({ ...props }: DeptWarnDialogProps) {
    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState([
        { id: 1, nome: 'A Vencer', count: 0, link: 'ocorrencias/vencer', color: '#ff9800', loading: true },
        { id: 2, nome: 'Vencidas', count: 0, link: 'ocorrencias/vencidas', color: '#ff5722', loading: true },
    ]);
    const history = useHistory();

    useEffect(() => {
        axios_instance
            .get<{ success: boolean, show: boolean, a_vencer: number, vencidas: number }>(`ouvidoria/counters/vencidas`)
            .then(res => {
                let r = res.data;
                if (r.success) {
                    setData([
                        { id: 1, nome: 'A Vencer', count: r.a_vencer, link: 'ocorrencias/vencer', color: '#ff9800', loading: false },
                        { id: 2, nome: 'Vencidas', count: r.vencidas, link: 'ocorrencias/vencidas', color: '#ff5722', loading: false },
                    ]);
                    setOpen(r.show);
                }
            })
            .catch(() => { });
    }, []);

    return <Dialog open={open} maxWidth="md" fullWidth onClose={() => { setOpen(false) }} PaperProps={{ style: { outlineColor: '#ff3711', outlineWidth: 4, outlineStyle: 'solid' } }}>
        <DialogTitle>
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
                <Report color="secondary" style={{ fontSize: 60 }} />
                <Typography variant="h3" gutterBottom color="secondary" align="center">
                    ALERTA DE PRAZO OUVIDORIA: <br />PROTOCOLOS PENDENTES DE RESPOSTAS.
                </Typography>
                <IconButton onClick={() => setOpen(false)}>
                    <Close />
                </IconButton>
            </Box>
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={3} alignItems='center' justifyContent='center'>
                {data.map(item => (
                    <Grid item xs={4} key={item.id}>
                        <Paper
                            elevation={3}
                            onClick={() => {
                                if (item.count > 0) history.push(`/${item.link}`)
                            }}
                            style={{
                                backgroundColor: item.count > 0 ? item.color : 'lightgrey',
                                cursor: item.count > 0 ? 'pointer' : 'default',
                            }}
                        >
                            <Box textAlign="center" p={3} color="white">
                                <h3>{item.nome}</h3>
                                <h1>{item.count}</h1>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <Box mt={5}>
                <Typography variant="h5" gutterBottom style={{ display: 'flex', fontWeight: "bold", alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <Warning htmlColor="#ffb02e" /> Há protocolos próximos do vencimento ou já vencidos no seu Departamento.
                </Typography>
                <Typography variant="h5" gutterBottom style={{ display: 'flex', fontWeight: "bold", alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <Warning htmlColor="#ffb02e" /> O prazo máximo é de 30 dias corridos a partir da data de abertura do protocolo.
                </Typography>
                <Typography variant="h5" gutterBottom style={{ display: 'flex', fontWeight: "bold", alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <Warning htmlColor="#ffb02e" /> Respostas fora do prazo impactam negativamente a transparência e a imagem da gestão.
                </Typography>
                <Typography variant="h5" gutterBottom style={{ display: 'flex', fontWeight: "bold", alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <Warning htmlColor="#ffb02e" /> Responder dentro do prazo é dever institucional.
                </Typography>
                <Typography variant="h5" color="error" gutterBottom style={{ display: 'flex', fontWeight: "bold", alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <Warning htmlColor="#ffb02e" /> Regularize imediatamente as pendências do seu Departamento.
                </Typography>
            </Box>
        </DialogContent>
    </Dialog>
}